// This file was auto-generated by Fern from our API Definition.
export var SessionRecordIngestRequest;
(function (SessionRecordIngestRequest) {
    SessionRecordIngestRequest.Kind = {
        Frame: "frame",
    };
})(SessionRecordIngestRequest || (SessionRecordIngestRequest = {}));
